/**
 * @generated SignedSource<<3945926e9a4939438f7feaba45fd77f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftExhibitionTileGrid_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer" | "NftItemTile_viewer">;
  readonly " $fragmentType": "NftExhibitionTileGrid_viewer";
};
export type NftExhibitionTileGrid_viewer$key = {
  readonly " $data"?: NftExhibitionTileGrid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionTileGrid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftExhibitionTileGrid_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e590c0ea0bc96fdd0248c16e557363e9";

export default node;
